import { styled } from "@mui/material/styles";
import { FormattedMessage } from "react-intl";

import { ToggleField } from "@/common/components/forms/toggle-field/ToggleField";
import { useToggle } from "@/shared/hooks/useToggle";

import { LicensePdf } from "./LicensePdf";

const LicenseAgreement = (): React.ReactElement => {
  const {
    on: isLicenseOpen,
    setOff: closeLicense,
    setOn: openLicense,
  } = useToggle();

  const handleLicenseClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();
    openLicense();
  };

  const label = (
    <>
      <FormattedMessage id="LicenseAgreement.iAgree" />{" "}
      <LicenseLink
        data-testid="license-agreement-link"
        onClick={handleLicenseClick}
      >
        <FormattedMessage id="LicenseAgreement.licenseAgreement" />
      </LicenseLink>
    </>
  );

  return (
    <Wrapper data-testid="license-agreement">
      <ToggleField fullWidth label={label} name="license" />
      <LicensePdf handleClose={closeLicense} open={isLicenseOpen} />
    </Wrapper>
  );
};

const Wrapper = styled("div")({
  position: "relative",
});

const LicenseLink = styled("a")(({ theme }) => ({
  color: theme.palette.cf.cfPrimary,
  cursor: "pointer",
  "&:visited, &:hover, &:focus": {
    color: theme.palette.cf.cfPrimary,
  },
}));

export { LicenseAgreement };
